export default __webpack_public_path__ + "static/media/paligon.447c8013.svg";